import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LobbyPanelComponent } from './panel/lobby-panel/lobby-panel.component';

const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('../app/pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/smart-home-auth.module').then(m => m.AuthModule),
  },
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: 'logout', redirectTo: 'pages/logout', pathMatch: 'full' },
  //{ path: 'authorizations-visitor', redirectTo: 'pages/authorizations-visitor', pathMatch: 'full' },
  { path: 'authorizations', redirectTo: 'pages/authorizations', pathMatch: 'full' },
  { path: 'invites', redirectTo: 'pages/invites', pathMatch: 'full' },
  { path: 'companies', redirectTo: 'pages/companies', pathMatch: 'full' },
  { path: 'residences', redirectTo: 'pages/residences', pathMatch: 'full' },
  { path: 'management', redirectTo: 'pages/management', pathMatch: 'full' },
  { path: 'schedule', redirectTo: 'pages/schedule', pathMatch: 'full' },
  { path: 'lobby-panel', component: LobbyPanelComponent, pathMatch: 'full' },
];

const config: ExtraOptions = {
  useHash: false,
  onSameUrlNavigation: 'reload'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
